<template>
  <v-row>
    <v-col cols="12" md="6" class="pa-4">
      <basket-item
        v-model:count="form.s1f2"
        v-model:docks-count="form.s1f2Dock"
        :title="t('components.devices.basket.title')"
        :img="imgDevicePeak"
        :specs="[
          t('components.devices.basket.specs.printer.screen'),
          t('components.devices.basket.specs.printer.connectivity'),
          t('components.devices.basket.specs.printer.weight'),
          t('components.devices.basket.specs.printer.accessories'),
        ]"
        :has-docks="true"
      />
    </v-col>
    <v-col cols="12" md="6" class="pa-4">
      <basket-item
        v-model:count="form.s1e2"
        :title="t('components.devices.basket.noPrinterTitle')"
        :img="imgDeviceSummit"
        :specs="[
          t('components.devices.basket.specs.noPrinter.screen'),
          t('components.devices.basket.specs.noPrinter.connectivity'),
          t('components.devices.basket.specs.noPrinter.weight'),
          t('components.devices.basket.specs.noPrinter.accessories'),
        ]"
        disabled
      />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import imgDevicePeak from "@/assets/img/yeti-peak-4g.png";
import imgDeviceSummit from "@/assets/img/yeti-summit-4g.png";

const { t } = useI18n();

const form = defineModel<{
  s1f2: number;
  s1f2Dock: number;
  s1e2: number;
}>("form", { default: () => ({ s1f2: 0, s1f2Dock: 0, s1e2: 0 }) });
</script>
